import React from 'react';

import RenderDropdown from 'forms/RenderDropdown';
import { Field } from 'react-final-form';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import { makeSelectOptions } from './selectors';

interface OwnProps {
    name: string;
    label?: string;
    validate?: any;
    nullOnUnmount?: boolean;
}

interface ConnectedProps {
    options?: {
        key: number;
        text: string;
        value: number;
    }[];
}

type Props = OwnProps & ConnectedProps;

export class SprayProductTypesDropdown extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const {
            name,
            label,
            validate,
            options,
            nullOnUnmount = false
        } = this.props;

        return (
            <Field
                component={RenderDropdown as any}
                subscription={{
                    value: true,
                    touched: true,
                    error: true
                }}
                name={name}
                label={label || 'Type'}
                placeholder="Choose a type"
                fluid
                search
                selection
                clearable
                selectOnBlur={false}
                validate={validate}
                options={options}
                nullOnUnmount={nullOnUnmount}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, ConnectedProps>({
    options: makeSelectOptions()
});

export default connect(mapStateToProps)(SprayProductTypesDropdown);
